 document.addEventListener('DOMContentLoaded', function () {
    // slide for the blog - The First Australian Chocolate Festival: A Success
    const swiperEl = document.querySelector('.ausiSlider');
    if (swiperEl && typeof Swiper !== 'undefined') {
      new Swiper('.ausiSlider', {
        slidesPerView: 0,
        spaceBetween: 30,
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 20, },
          768: { slidesPerView: 2, spaceBetween: 20, },
          991: { slidesPerView: 3, spaceBetween: 30, }
        }
      });
    }

    // Audio play-pause and download
     const playButtons = document.querySelectorAll('.play-btn');
  const pauseButtons = document.querySelectorAll('.pause-btn');
  const audios = document.querySelectorAll('audio');

  if (!playButtons.length || !pauseButtons.length || !audios.length) return;
  function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  }

  playButtons.forEach((play) => {
    play.addEventListener('click', () => {
      const id = play.dataset.id;
      const audio = document.getElementById('audio-' + id);
      const pause = document.querySelector('.pause-btn[data-id="' + id + '"]');
      const timeLabel = document.getElementById('time-' + id);

      if (!audio || !pause || !timeLabel) return;

      document.querySelectorAll('audio').forEach((a) => a.pause());
      document.querySelectorAll('.pause-btn').forEach((p) => (p.style.display = 'none'));
      document.querySelectorAll('.play-btn').forEach((p) => (p.style.display = 'inline-block'));

      audio.play();
      play.style.display = 'none';
      pause.style.display = 'inline-block';

      audio.addEventListener('loadedmetadata', () => {
        timeLabel.textContent = `0:00 / ${formatTime(audio.duration)}`;
      });
      audio.addEventListener('timeupdate', () => {
        timeLabel.textContent = `${formatTime(audio.currentTime)} / ${formatTime(audio.duration)}`;
      });
    });
  });
  pauseButtons.forEach((pause) => {
    pause.addEventListener('click', () => {
      const id = pause.dataset.id;
      const audio = document.getElementById('audio-' + id);
      const play = document.querySelector('.play-btn[data-id="' + id + '"]');
      if (!audio || !play) return;
      audio.pause();
      pause.style.display = 'none';
      play.style.display = 'inline-block';
    });
  });
  audios.forEach((audio) => {
    audio.addEventListener('ended', () => {
      const id = audio.id.replace('audio-', '');
      const play = document.querySelector('.play-btn[data-id="' + id + '"]');
      const pause = document.querySelector('.pause-btn[data-id="' + id + '"]');
      if (!play || !pause) return;
      play.style.display = 'inline-block';
      pause.style.display = 'none';
    });
  });
  });

   function formatTime(seconds) {
      if (isNaN(seconds)) return '0:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }

    // Initialize all audio players
    document.querySelectorAll('.ctm_audio-item').forEach(item => {
      const player = item.querySelector('.audio-player');
      const audioId = player.dataset.audioId;
      const audio = document.getElementById(`audio-${audioId}`);
      const playBtn = item.querySelector(`.play-btn[data-id="${audioId}"]`);
      const pauseBtn = item.querySelector(`.pause-btn[data-id="${audioId}"]`);
      const timeDisplay = document.getElementById(`time-${audioId}`);
      // const downloadLink = item.querySelector('.download-link');

      // Play button
      playBtn.addEventListener('click', () => {
        document.querySelectorAll('audio').forEach(a => {
          if (a !== audio && !a.paused) {
            a.pause();
            const otherId = a.id.replace('audio-', '');
            document.querySelector(`.play-btn[data-id="${otherId}"]`).style.display = 'flex';
            document.querySelector(`.pause-btn[data-id="${otherId}"]`).style.display = 'none';
          }
        });

        audio.play();
        playBtn.style.display = 'none';
        pauseBtn.style.display = 'flex';
      });

      // Pause button
      pauseBtn.addEventListener('click', () => {
        audio.pause();
        playBtn.style.display = 'flex';
        pauseBtn.style.display = 'none';
      });

      // Update time display
      audio.addEventListener('loadedmetadata', () => {
        timeDisplay.textContent = `0:00 / ${formatTime(audio.duration)}`;
      });

      audio.addEventListener('timeupdate', () => {
        timeDisplay.textContent = `${formatTime(audio.currentTime)} / ${formatTime(audio.duration)}`;
      });

      // Reset when audio ends
      audio.addEventListener('ended', () => {
        playBtn.style.display = 'flex';
        pauseBtn.style.display = 'none';
        audio.currentTime = 0;
      });

      // Download functionality - Force download using fetch
      // downloadLink.addEventListener('click', async (e) => {
      //   e.preventDefault();
        
      //   const audioSrc = downloadLink.dataset.audioSrc;
      //   const filename = downloadLink.dataset.filename || 'audio.m4a';
        
      //   const originalText = downloadLink.textContent;
      //   downloadLink.textContent = 'Downloading...';
      //   downloadLink.style.pointerEvents = 'none';
        
      //   try {
      //     // Fetch the audio file with no-cors mode
      //     const response = await fetch(audioSrc, {
      //       mode: 'cors',
      //       cache: 'no-cache'
      //     });
          
      //     if (!response.ok) {
      //       throw new Error('Download failed');
      //     }
          
      //     // Get the blob
      //     const blob = await response.blob();
      //     const blobUrl = window.URL.createObjectURL(blob);

      //     const tempLink = document.createElement('a');
      //     tempLink.style.display = 'none';
      //     tempLink.href = blobUrl;
      //     tempLink.download = filename;
          
      //     document.body.appendChild(tempLink);
      //     tempLink.click();
          
      //     // Cleanup
      //     setTimeout(() => {
      //       document.body.removeChild(tempLink);
      //       window.URL.revokeObjectURL(blobUrl);
      //     }, 100);
          
      //     downloadLink.textContent = originalText;
      //     downloadLink.style.pointerEvents = 'auto';
          
      //   } catch (error) {
      //     console.error('Download error:', error);
          
      //     window.open(audioSrc, '_blank');
      //     downloadLink.textContent = originalText;
      //     downloadLink.style.pointerEvents = 'auto';
      //   }
      // });
      
    });